import { render, staticRenderFns } from "./purchase-invoices.vue?vue&type=template&id=41538622&scoped=true"
import script from "./purchase-invoices.vue?vue&type=script&lang=js"
export * from "./purchase-invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41538622",
  null
  
)

export default component.exports